export default {
    "real": "Received",
    "failed": "Damaged",
    "lost": "Lost",
    "switched": "Switched",
}
